import { API_ROUTE_ADMIN_REPORTS_CUSTOER_SPECIFIC } from '@/resources/api-routes'
import { get } from '@/util/auth'

const IS_NEW_BACKEND_API = true

export type CustomerSetupExportMapping = {
  name: string | null
  customerId: number | null
  customerHeadId: number | null
  type: string | null
  report: string | null
  format: string | null
  url: string | null
  parameters: string | null
}

export const getCustomerSpecificReports = async () =>
  get<CustomerSetupExportMapping[]>(API_ROUTE_ADMIN_REPORTS_CUSTOER_SPECIFIC, IS_NEW_BACKEND_API)
